import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { ALLOWED_EXTENSIONS } from '../constants';

interface DropZoneSectionProps {
  isDragOver: boolean;
  onDragOver: (event: React.DragEvent) => void;
  onDragLeave: (event: React.DragEvent) => void;
  onDrop: (event: React.DragEvent) => void;
  onClick: () => void;
}

export const DropZoneSection: React.FC<DropZoneSectionProps> = ({
  isDragOver,
  onDragOver,
  onDragLeave,
  onDrop,
  onClick,
}) => (
  <Box>
    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
      Select Documents to Upload
    </Typography>

    <Paper
      sx={{
        p: 4,
        textAlign: 'center',
        cursor: 'pointer',
        border: '2px dashed',
        borderColor: isDragOver ? '#3b82f6' : '#e2e8f0',
        backgroundColor: isDragOver ? '#eff6ff' : '#f8fafc',
        borderRadius: 2,
        transition: 'all 0.2s ease',
        '&:hover': {
          borderColor: '#3b82f6',
          backgroundColor: '#f0f9ff',
        },
      }}
      onClick={onClick}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <CloudUpload
        sx={{
          fontSize: 48,
          color: isDragOver ? '#3b82f6' : '#94a3b8',
          mb: 2,
        }}
      />
      <Typography
        variant="h6"
        sx={{
          mb: 1,
          color: isDragOver ? '#3b82f6' : '#64748b',
        }}
      >
        {isDragOver ? 'Drop files here' : 'Click to browse files'}
      </Typography>
      <Typography variant="body2" sx={{ color: '#94a3b8', mb: 2 }}>
        {isDragOver ? 'Release to add files' : 'or drag and drop files here'}
      </Typography>
      <Typography variant="caption" sx={{ color: '#94a3b8' }}>
        Supported formats: {ALLOWED_EXTENSIONS.join(', ')} • Max size: 10MB per file
      </Typography>
    </Paper>
  </Box>
);

export default DropZoneSection;
